import { render } from "./CmdRm.vue?vue&type=template&id=3bef4318"
import script from "./CmdRm.vue?vue&type=script&lang=js"
export * from "./CmdRm.vue?vue&type=script&lang=js"

import "./CmdRm.vue?vue&type=style&index=0&id=3bef4318&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__